import React, { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const HeaderOne = () => {
  const [search, setSearch] = useState(false);
  const [offCanvas, setOffCanvas] = useState(false);

  useEffect(() => {
    var offCanvasNav = document.getElementById("offcanvas-navigation");
    var offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu");

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      offCanvasNavSubMenu[i].insertAdjacentHTML(
        "beforebegin",
        "<span class='menu-expand'><i></i></span>"
      );
    }

    var menuExpand = offCanvasNav.querySelectorAll(".menu-expand");
    var numMenuExpand = menuExpand.length;

    function sideMenuExpand() {
      if (this.parentElement.classList.contains("active") === true) {
        this.parentElement.classList.remove("active");
      } else {
        for (let i = 0; i < numMenuExpand; i++) {
          menuExpand[i].parentElement.classList.remove("active");
        }
        this.parentElement.classList.add("active");
      }
    }

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", sideMenuExpand);
    }
  }, []);

  const searchControl = () => {
    setSearch(!search);
  };
  const offCanvasControl = () => {
    setSearch(false);
    setOffCanvas(!offCanvas);
  };
  return (
    <>
      {/* Header area start */}
      <header className="header__area plr-100">
        <div className="header__inner">
          <div className="header__logo">
            <Link to="/">
              <img src="/assets/imgs/logo/logo.png" alt="Site Logo" />
            </Link>
          </div>
          <div className="header__menu">
            <nav className="main-menu">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/service">Service</Link>
                </li>
                <li>
                  <Link to="/industries-we-functioned">Industries</Link>
                </li>
                {/* <li className="has-megamenu">
                  <Link to="#">Industries we functioned</Link>
                  <div className="mega-menu">
                    <ul>
                      <li>home</li>
                      <li>
                        <Link to="/">Creative Agency</Link>
                      </li>
                      <li>
                        <Link to="/index-2">Digital Marketing</Link>
                      </li>
                      <li>
                        <Link to="/index-3">Creative Agency Dark</Link>
                      </li>
                      <li>
                        <Link to="/index-4">Digital Marketing Dark</Link>
                      </li>
                      <li>
                        <Link to="/index-5">Creative Band</Link>
                      </li>
                    </ul>
                    <ul>
                      <li>service</li>
                      <li>
                        <Link to="/service-details">Service details</Link>
                      </li>
                    </ul>
                    <ul>
                      <li>portfolio</li>
                      <li>
                        <Link to="/project">portfolio</Link>
                      </li>
                      <li>
                        <Link to="/project-details">portfolio details</Link>
                      </li>
                    </ul>
                    <ul>
                      <li>Our Team</li>
                    </ul>
                  </div>
                </li> */}
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="header__others">
            <div className="header__search">
              <button
                className={!search ? "search-icon" : "search-icon d-none"}
                onClick={searchControl}
              >
                <i className="fa-solid fa-magnifying-glass" />
              </button>
              <button
                className={search ? "search-close d-inline" : "search-close "}
                onClick={searchControl}
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="header__offcanvas">
              <button className="menu_icon" onClick={offCanvasControl}>
                <img src="/assets/imgs/icon/menu.png" alt="Menu Icon" />
              </button>
            </div>
          </div>
        </div>
      </header>
      <div className={!search ? "search__form" : "search__form showed"}>
        <form action="#">
          <input type="text" name="s" placeholder="Search..." />
        </form>
      </div>
      {/* Offcanvas area start */}
      <div
        className={!offCanvas ? "offcanvas__area" : "offcanvas__area showed"}
      >
        <div className="offcanvas__inner">
          <div className="offcanvas__top">
            <img src="/assets/imgs/logo/logo.png" alt="Logo" />
            <button id="offcanvas_close" onClick={offCanvasControl}>
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
          <div className="offcanvas__search">
            <form action="#">
              <input type="text" placeholder="Search..." name="s" />
            </form>
          </div>
          <div className="offcanvas__menu">
            <nav className="offcanvas-navigation" id="offcanvas-navigation">
            <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/Service">Service</Link>
                </li>
                <li>
                  <Link to="/industries-we-functioned">Industries</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="offcanvas__map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3471.910331304133!2d-95.74022942446622!3d29.518972775192328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86411d7bb5b38963%3A0x645538175a764331!2s7207%20Dawn%20Vw%20Ln%2C%20Rosenberg%2C%20TX%2077469%2C%20USA!5e0!3m2!1sen!2sin!4v1719330505795!5m2!1sen!2sin"
              loading="lazy"
              title="digibold"
            />
          </div>
          <div className="offcanvas__btm">
            <div className="footer__address-3">
              <ul>
                <li>
                  <span>
                    <i className="fa-solid fa-location-dot" />
                  </span>
                  <p className="text-white">
                  Smart Itech LLC <br/>
                  6103 OAKDALE FALLS DR <br />
                  ROSENBERG TX,7746
                  </p>
                </li>
                <li>
                  <span>
                    <i className="fa-solid fa-phone" />
                  </span>
                  <div>
                    <Link to="tel: 832-535-1175">  832-535-1175</Link>
                  </div>
                </li>
                <li>
                  <span>
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <div>
                    <Link to="mailto:info@driller.com">info@smartitech.com</Link>
                   
                  </div>
                </li>
              </ul>
            </div>
            <div className="footer__social-3">
              <ul>
                <li>
                  <Link to="#">
                    <i className="fa-brands fa-facebook-f" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fa-brands fa-twitter" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fa-brands fa-instagram" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Offcanvas area end */}
    </>
  );
};

export default HeaderOne;
